import {getEntryPointDataFailed, getEntryPointDataSuccess} from "modules/actions/entryActions";

import {fetchPlayersSaga, fetchSuggestedPlayersSaga} from "modules/sagas/players";
import fetchRoundsSaga from "modules/sagas/rounds";
import {fetchSettingSaga} from "modules/sagas/settings";
import fetchSquadsSaga from "modules/sagas/squads";
import fetchUnitsSaga, {fetchHistoryUnitsSaga} from "modules/sagas/units";
import {all, call, put} from "typed-redux-saga";
import fetchRewardStatsSaga from "modules/sagas/rewardStats";

export const getEntryPointDataSaga = function* () {
	try {
		const sagas = [
			fetchPlayersSaga,
			fetchSuggestedPlayersSaga,
			fetchRoundsSaga,
			fetchSquadsSaga,
			fetchUnitsSaga,
			fetchHistoryUnitsSaga,
			fetchRewardStatsSaga,
			fetchSettingSaga,
		];

		yield* all(sagas.map(call));
		yield* put(getEntryPointDataSuccess());
	} catch (e) {
		yield* put(getEntryPointDataFailed());
	}
};
